import requestAdmin from '@/utils/requestAdmin.js'

// 获取列表和搜索字段
export function getEnum() {
    return requestAdmin({
        url: `form-item/enum/status`,
        method: 'get'
    })
}
